import { HeaderWrapper } from "@/components/base/header-wrapper"
import ListContainer from "@/components/widget/page-container/list-container"
import TitleWrapper from "@/components/widget/page-container/list-container/title-wrapper"
import ListTable from "@/components/widget/list-table"
import { DeleteModal } from "@/components/widget/modal-delete"

import useLogic from "@/hooks/users/list/useLogic"
import { Paper } from "@mui/material"

const UserList = () => {
    const {
        handleChangePage,
        handleCloseModal,
        handleDelete,
        handleDeleteUser,
        handleEdit,
        items,
        setStateUiPageSession,
        t,
        metadata,
        userToDelete,
        loading,
    } = useLogic()

    return (
        <>
            <ListContainer>
                <TitleWrapper pageIcon="user" title={t("USERS.TITLE")} />
                <HeaderWrapper
                    buttonText={t("USERS.CREATE_BUTTON")}
                    onClickButton={() => {
                        setStateUiPageSession({ showPage: "create" })
                    }}
                    showActionButton
                />

                <Paper>
                    <ListTable
                        isLoading={loading}
                        handleChangePage={handleChangePage}
                        metadata={metadata}
                        rows={items}
                        handleDelete={handleDelete}
                        handleEdit={handleEdit}
                        generateLabels={(row) => [`${row.firstname} ${row.lastname}`]}
                        toolTipDeleteText={t("USERS.DELETE.TRASH")}
                        toolTipEditText={t("USERS.EDIT")}
                        toolTipRowText={t("USERS.VIEW_TOOLTIP")}
                    />
                </Paper>
            </ListContainer>
            <DeleteModal
                open={!!userToDelete}
                onClose={handleCloseModal}
                title={t("USERS.DELETE.TITLE")}
                description={t("USERS.DELETE.ASK")}
                loading={loading}
                onDelete={() => {
                    handleDeleteUser()
                }}
            />
        </>
    )
}

export default UserList
